import { createStyles } from '@material-ui/core';
import { Colors } from 'bz-core-controls/styles/colours';

export default createStyles({
  root: {
    maxWidth: '100vw',
    display: 'grid',
    gridTemplateRows: 'auto',
    gridAutoFlow: 'row',
    gridAutoRows: '1fr',
    height: '100%'
  },
  header: {
    fontFamily: 'Montserrat',
    background: Colors.blueGrey900,
    borderLeft: `12px solid ${Colors.blue}`,
    textTransform: 'uppercase',
    fontSize: 14,
    color: 'white'
  },
  headerInner: {
    borderLeft: `4px solid ${Colors.white}`,
    paddingRight: 10,
    display: 'grid',
    gridColumnGap: '10px',
    gridTemplateColumns: '0fr  auto minmax(auto, 80px)',
    alignItems: 'center'
  },
  body: {
    maxWidth: '100vw',
    overflowY: 'auto'
  },
  small: {}, // pseudo class used for media query
  large: {}, // pseudo class used for media query
  '@media (min-width: 600px)': {
    root: {
      minWidth: 600,
      maxWidth: 600,
      '&$small': {
        maxWidth: 400,
        minWidth: 400
      }
    }
  },
  '@media (min-width: 800px)': {
    root: {
      '&$large': {
        maxWidth: 800,
        minWidth: 800
      }
    }
  },
  loadingStyle: {
    textAlign: 'center',
    paddingTop: 20
  }
});
